var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 23.5,
    fill: "#1B9075",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.277 27.0086L11.2775 35.63L11.0287 36.3458C10.8929 36.7376 11.2623 37.107 11.6542 36.9713L12.37 36.7225L20.9914 33.7229C21.0479 33.704 21.1006 33.674 21.142 33.6326L14.3673 26.8577C14.3259 26.8993 14.2957 26.952 14.277 27.0086Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0578 13.1794L34.8195 10.9411C33.5648 9.68631 31.5298 9.68631 30.275 10.9411L28.0254 13.1907L34.8079 19.9732L37.0576 17.7236C38.3126 16.4691 38.3126 14.4344 37.0578 13.1794Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8964 14.3214L15.4941 25.7236L22.2766 32.5061L33.6789 21.1038L26.8964 14.3214Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.7471d6a97707902b5b5d6be88d9da9df.svg";
export { ForwardRef as ReactComponent };